import type { TSkuSelectorProduct } from '../models';

export class CharacteristicsKeyGenerator {
  static byIds(ids: number[]): string {
    return ids.join('_');
  }

  static byProduct(product: TSkuSelectorProduct, skuGroupIds: number[]): string {
    const { characteristicValues } = product;

    const ids = skuGroupIds.map((skuGroupId) => {
      return characteristicValues.find((it) => it.characteristicId === skuGroupId)?.id;
    });

    return this.byIds(ids);
  }
}
